import { render, staticRenderFns } from "./BaseExhibitionCarousel.vue?vue&type=template&id=eee1a8ae&scoped=true&"
import script from "./BaseExhibitionCarousel.vue?vue&type=script&lang=js&"
export * from "./BaseExhibitionCarousel.vue?vue&type=script&lang=js&"
import style0 from "./BaseExhibitionCarousel.vue?vue&type=style&index=0&id=eee1a8ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eee1a8ae",
  null
  
)

export default component.exports